module.exports = __webpack_public_path__ + "img/9788984315204.0ddeaa72.jpg";